export const permission = [
  {
    path: "/permission/role",
    name: "PermissionRole",
    component: () => import("@/views/permissionSettings/index.vue"),
    meta: {
      title: "角色管理",
      menuId: "1861283974676426752",
      icon: "shangpin",
    },
  },
  {
    path: "/permission/menber",
    name: "PermissionMenber",
    component: () => import("@/views/permissionSettings/menber.vue"),
    meta: {
      title: "人员管理",
      menuId: "1861283974676426752",
      icon: "shangpin",
    },
  },
  {
    path: "/customerManagement",
    name: "CustomerManagement",
    component: () => import("@/views/customerManagement/index.vue"),
    meta: {
      title: "客户管理",
      menuId: "1861283974676426752",
      icon: "shangpin",
    },
  },
  {
    path: "/myInformation",
    name: "MyInformation",
    component: () => import("@/views/myInformation/index.vue"),
    meta: {
      title: "我的资料",
      menuId: "1861283974676426752",
      icon: "shangpin",
    },
  },
  {
    path: "/inviteHistory",
    name: "InviteHistory",
    component: () => import("@/views/inviteHistory/index.vue"),
    meta: {
      title: "邀请记录",
      menuId: "1861283974676426752",
      icon: "shangpin",
    },
  },
  {
    path: "/logoList",
    name: "logoList",
    component: () => import("@/views/logoManagement/index.vue"),
    meta: {
      title: "LOGO替换记录",
      menuId: "no",
    },
  },
  {
    path: "/addLogo",
    name: "addLogo",
    component: () => import("@/views/logoManagement/addLogo.vue"),
    meta: {
      title: "logo定制",
      menuId: "no",
    },
  },
];
